type ZonesRetrievalError = {
  wasPlanzoneNotFound: boolean;
  hasUnexpectedError: boolean;
  message: string;
};

const zonesRetrievalError: ZonesRetrievalError = {
  wasPlanzoneNotFound: false,
  hasUnexpectedError: false,
  message: "",
};

export type { ZonesRetrievalError };

export { zonesRetrievalError };
